import { Heading, HFlow, Text, VFlow } from 'bold-ui'
import React from 'react'
import { formatDate } from 'util/date/formatDate'
import StatusSquare from 'view/atendimentos/detail/historico/components/StatusSquare'
import { cuidadoCompartilhadoClassificacaoPrioridadeRecord } from 'view/atendimentos/detail/soap/plano/cuidado-compartilhado/model-cuidadocompartilhado'

import { RegulacaoItem, RegulacaoModalItemProps } from './RegulacaoItem'

export const RegulacaoModalItemGuiaEncaminhamento = (props: Readonly<RegulacaoModalItemProps>) => {
  const { item } = props
  const { lotacao } = item
  const { ciap, cid10, classificacaoPrioridade, cbo, atendimentoProfissional } = item.guiaEncaminhamento
  const { label, mainColor } = cuidadoCompartilhadoClassificacaoPrioridadeRecord[classificacaoPrioridade]

  const solicitanteLabel = [
    lotacao.profissional.nome,
    lotacao.cbo.nome,
    lotacao.equipe?.nome ?? 'Sem equipe',
    lotacao.unidadeSaude.nome,
  ]
    .filterNotNull()
    .join(' | ')

  return (
    <VFlow vSpacing={0.5}>
      <RegulacaoItem title='CBO' subtitle={cbo.nome} />
      <RegulacaoItem title='Solicitante' subtitle={solicitanteLabel} />
      <VFlow vSpacing={0}>
        <Heading level={5} fontWeight='bold'>
          Problemas e condições
        </Heading>
        <Heading level={5} fontWeight='normal'>
          <VFlow vSpacing={0}>
            {ciap && `${ciap.descricao} - ${ciap.codigo} (CIAO2)`}
            {cid10 && `${cid10.nome} - ${cid10.codigo} (CID10)`}
          </VFlow>
        </Heading>
      </VFlow>
      <RegulacaoItem
        title='Discussão'
        subtitle={<Text dangerouslySetInnerHTML={{ __html: item.guiaEncaminhamento.discussao ?? '-' }} />}
      />
      <HFlow hSpacing={2}>
        <VFlow vSpacing={0}>
          <Heading level={5} fontWeight='bold'>
            Prioridade
          </Heading>
          <StatusSquare color={mainColor} description={label} />
        </VFlow>
        <RegulacaoItem title='Data da solicitação' subtitle={formatDate(atendimentoProfissional.finalizadoEm)} />
      </HFlow>
    </VFlow>
  )
}
